import styled from 'styled-components';

interface DotProps {
  $isVisible: boolean;
}

export const Dot = styled.div<DotProps>(({ theme: { size, color }, $isVisible }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: size.units(1.5),
  height: size.units(1.5),
  borderRadius: '50%',
  backgroundColor: color.background.secondary.active(),
  boxShadow: '0 0 4px rgba(0, 0, 0, 0.4)',
  pointerEvents: 'none',
  zIndex: 10,
  transition: 'transform 16.67ms linear, opacity 350ms ease-in-out',
  opacity: $isVisible ? 1 : 0,
  willChange: 'transform',
}));
